import { createNamespacedHelpers } from 'vuex'
import { INSURANCE } from '../interface/insurance'
import { merge } from 'lodash'

const initState = {
  insurance: {},
}

const mutations = {
  [INSURANCE.INSURANCE](state, paylod) {
    state.insurance = merge(state.insurance, paylod)
  },
  [INSURANCE.CLEAR](state) {
    state.insurance = {}
  },
}

const { mapMutations, mapState } = createNamespacedHelpers('insurance')

export { mapMutations, mapState, INSURANCE }

export default {
  namespaced: true,
  state: initState,
  mutations: mutations,
}
